import clsx from "clsx";
import React from "react";
import { List, ListProps, Typography, Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { RecipientListItem } from "./RecipientListItem";
import {
  MessageGroupDto,
  RecipientsDto,
} from "@growth-machine-llc/stridist-api-client";
import { EnrollDialogEmpty } from "../dialog/EnrollDialogEmpty";

const useStyles = makeStyles((theme) => ({
  root: {},

  empty: {
    marginTop: theme.spacing(3),
  },
}));

export interface RecipientListProps extends Omit<ListProps, "onSelect"> {
  recipients: RecipientsDto[];
  onLoadMore: () => void;
  loading: boolean;
  hasNext: boolean;
  onSelect?: (event: React.MouseEvent, username?: string) => void;
  selectedRecipient?: RecipientsDto | null;
  singleSelect?: boolean;
  debounceQuery?: string;
}

export function RecipientList(props: RecipientListProps) {
  const {
    className,
    onSelect,
    onLoadMore,
    recipients,
    loading,
    hasNext,
    selectedRecipient,
    singleSelect,
    debounceQuery,
    ...other
  } = props;
  const s = useStyles();

  const handleMoreClick = React.useCallback(() => {
    !loading && onLoadMore();
  }, [loading, onLoadMore]);

  return recipients.length > 0 ? (
    <>
      <List className={clsx(s.root, className)} {...other}>
        {recipients.map((recipient, index) => (
          <RecipientListItem
            key={index}
            recipient={recipient}
            onToggle={() => onSelect?.(null as any, recipient.user?.username)}
            selected={
              selectedRecipient?.user?.username === recipient.user?.username
            }
            divider={index < recipients.length - 1}
          />
        ))}
      </List>
      {hasNext && (
        <Button onClick={handleMoreClick} fullWidth disabled={loading}>
          Load more
        </Button>
      )}
    </>
  ) : (
    <EnrollDialogEmpty
      header={debounceQuery ? "No clients match your search" : "No clients"}
    />
  );
}
